import * as React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { IconMessages as MessageSquare, IconMenu2 as Menu, IconRobot as Bot } from '@tabler/icons-react';
import { cn } from '@heroui/react';

interface MenuItem {
  key: string;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
  path: string;
  disabled?: boolean;
}

const menuItems: MenuItem[] = [
  {
    key: 'customer-service',
    label: '客服消息',
    icon: MessageSquare,
    path: '/wechat/customer-service',
  },
  {
    key: 'menu-management',
    label: '菜单管理',
    icon: Menu,
    path: '/wechat/menu-management',
  },
  {
    key: 'auto-reply',
    label: '自动回复',
    icon: Bot,
    path: '/wechat/auto-reply',
    disabled: true,
  },
];

export function WechatSidebar() {
  const navigate = useNavigate();
  const location = useLocation();

  const selectedKey = React.useMemo(() => {
    const currentPath = location.pathname;
    if (currentPath === '/wechat' || currentPath === '/wechat/') {
      return 'customer-service';
    }
    for (const item of menuItems) {
      if (currentPath === item.path || currentPath.startsWith(item.path + '/')) {
        return item.key;
      }
    }
    return 'customer-service';
  }, [location.pathname]);

  const handleMenuClick = (item: MenuItem) => {
    if (item.disabled) return;
    navigate(item.path);
  };

  return (
    <div className="flex h-full w-40 flex-col border-r border-divider bg-sidebar">
      {/* 头部 */}
      <div className="flex h-14 items-center border-b border-divider px-4">
        <h2 className="text-base font-bold">微信管理</h2>
      </div>

      {/* 菜单内容 */}
      <div className="flex-1 overflow-y-auto p-3">
        <div className="space-y-1">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = selectedKey === item.key;
            return (
              <button
                key={item.key}
                onClick={() => handleMenuClick(item)}
                disabled={item.disabled}
                className={cn(
                  'w-full flex items-center gap-2 px-2 py-1.5 rounded-md text-sm transition-colors',
                  'hover:bg-accent hover:text-accent-foreground',
                  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
                  isActive && 'bg-accent text-accent-foreground font-medium',
                  item.disabled && 'opacity-50 cursor-not-allowed hover:bg-transparent hover:text-current'
                )}
              >
                <Icon className="size-4 shrink-0" />
                <span className="truncate">{item.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
